import { useState } from 'react';
import { BarChart3 } from 'lucide-react';
import {
  useWaapMonitoringCharts,
  MONITORING_TIME_RANGES,
  type MonitoringTimeRange,
} from '@/api/waap';
import { useWaapWebsite } from '@/pages/services/waap/waap-context';
import { WaapAnalyticsBoard } from './WaapAnalyticsBoard';

/**
 * Analytics → Monitoring — NATIVE charts (Superset dashboard 69) rendered through
 * the shared board shell (Domain + Time Range toolbar + chart grid).
 */
export function MonitoringTab() {
  const { selected } = useWaapWebsite();
  const [range, setRange] = useState<MonitoringTimeRange>('Last 12 Hours');
  const [domains, setDomains] = useState<string[]>([]);
  const query = useWaapMonitoringCharts(selected?.domainId, range, domains);
  return (
    <WaapAnalyticsBoard
      icon={<BarChart3 size={26} />}
      label="monitoring"
      ranges={MONITORING_TIME_RANGES}
      range={range}
      onRangeChange={setRange}
      domains={domains}
      onDomainsChange={setDomains}
      query={query}
    />
  );
}
